import { render, staticRenderFns } from "./RappVentePos.vue?vue&type=template&id=6f83ed4b&scoped=true&"
import script from "./RappVentePos.vue?vue&type=script&lang=js&"
export * from "./RappVentePos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f83ed4b",
  null
  
)

export default component.exports